const styles = (theme) => ({
    table: {
        margin: '0 0 30px 0',
    },
    tableRow: {
        verticalAlign: 'middle',
    },
    headTableCellDark: {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.common.white,
        minWidth: '100px',
    },
    headTableCellDarkField: {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.common.white,
        minWidth: '300px',
    },
    textDark: {
        color: theme.palette.primary.dark,
    },
    tableCell: {
        overflowWrap: 'anywhere',
    },
    list: {
        listStyle: 'none',
    },
    listItem: {
        marginBottom: '20px',
    },
    listItemNoMargin: {
        marginBottom: '0px',
    },
});

export default styles;
